import React from 'react';
import Alert from 'components/ui/Alert';
import { accessorialPaid } from 'helpers/accessorials';
const CarrierMismatchBanner = ({ t, accessorial, shipment }) => {
    var _a, _b;
    const shipmentCarrier = ((_a = shipment === null || shipment === void 0 ? void 0 : shipment.carrier) === null || _a === void 0 ? void 0 : _a._id) || (shipment === null || shipment === void 0 ? void 0 : shipment.carrier);
    const carrierAssociatedWithAccessorial = ((_b = accessorial.carrier) === null || _b === void 0 ? void 0 : _b._id) || accessorial.carrier;
    const carrierMismatch = accessorial.payee_type === 'carrier' &&
        shipmentCarrier !== carrierAssociatedWithAccessorial;
    const payableIsProcessed = accessorialPaid(shipment, accessorial);
    const alreadyDeclined = accessorial.carrier_status === 'declined';
    if (!carrierMismatch || payableIsProcessed || alreadyDeclined) {
        return null;
    }
    return (React.createElement(Alert, { dataTestId: "Alert-Carrier-Mismatch-Info", type: "info", className: "mb-4" }, t('CARRIER_MISMATCH_DECLINE_INFO', {
        defaultValue: 'The carrier on this accessorial does not match the shipment carrier. You can still manually decline this accessorial if needed.',
    })));
};
export default CarrierMismatchBanner;
